import { generatePath, useLoaderData, useLocation } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { omaElisaForCompaniesMsg, t, voiceSubscriptionsMsg } from '../../../../../common/i18n';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { AddonDetails } from '../../../../../components/AddonDetails/AddonDetails.js';
import { BreadCrumbs } from '../../../../../components/BreadCrumbs';
import type { SubscriptionAddOnLoaderResponse } from '../../../../../common/loaders';

export const MobileSubAddOnPath = () => {
  const { search } = useLocation();
  const { addOn, hasPendingActions, subscription } = useLoaderData() as SubscriptionAddOnLoaderResponse;

  return (
    <AddonDetails
      addOn={addOn}
      breadCrumbs={
        <BreadCrumbs
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.AR0B(voiceSubscriptionsMsg), path: paths.PS_MOBILE_SUBSCRIPTIONS },
            {
              name: getSubscriptionBreadcrumbName(subscription),
              path:
                generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) +
                search,
            },
            { name: addOn?.addOnProductName || '...' },
          ]}
        />
      }
      subscription={subscription}
      hasPendingActions={hasPendingActions}
      subscriptionPath={paths.PS_MOBILE_SUBSCRIPTION}
    />
  );
};
